import { render, staticRenderFns } from "./quotationInfo.vue?vue&type=template&id=4106d79c&scoped=true&"
import script from "./quotationInfo.vue?vue&type=script&lang=js&"
export * from "./quotationInfo.vue?vue&type=script&lang=js&"
import style0 from "./quotationInfo.vue?vue&type=style&index=0&id=4106d79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106d79c",
  null
  
)

export default component.exports